import React from "react";
import PropTypes from "prop-types";
import Icon from "../icon";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  side: PropTypes.string,
};

const defaultProps = {
  side: "right",
};

const NavigationButton = ({ label, onClick, side }) => {
  const defaultClasses = [
    "flex",
    "md:flex-col",
    "md:justify-center",
    "items-center",
    "w-1/5",
    "md:w-12",
    "absolute",
  ];

  conditionallyAddStyles(
    side === "right",
    defaultClasses,
    "right-4 md:right-6 flex-row-reverse",
    "left-4 md:left-6"
  );

  return (
    <button className={defaultClasses.join(" ")} onClick={onClick}>
      <Icon
        className={
          side === "left" ? "transform rotate-180 mr-2 md:ml-0" : "ml-2 md:ml-0"
        }
        iconName="NavigationArrow"
      />
      <div className="navigation-text leading-none md:mt-3">{label}</div>
    </button>
  );
};

NavigationButton.propTypes = propTypes;

NavigationButton.defaultProps = defaultProps;

export default NavigationButton;
